<template>
  <div class="idCardLoading">
    <!--顶部导航-->
    <Navbar title="资质认证" :isSpecialBack="true" @goBack="handleBack" />
    <!-- 信息收集进度条-->
    <progressField :flag="1" />
    <div class="progress-block">

    </div>
    <div class="LiveDetection">
      <authenticAtionPending ref="authenticAtionPendingRef" />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import progressField from "@/components/progress/index.vue";
import authenticAtionPending from "@/components/idCardBinding/authenticAtionPending.vue";
import { verificationIdCardOCRWebCallback, preCheck } from "@/api/index";
import { setLocalStorageData } from "@/common/index.js";
export default {
  name: "idCardLoading",
  components: {
    Navbar,
    progressField,
    authenticAtionPending,
  },
  data() {
    return {
      time: 0,
      timer: null,
    };
  },
  async mounted() {
    this.timer = setInterval(async () => {
      this.time++;
      let res = await verificationIdCardOCRWebCallback();
      if (
        res.code == 2000 &&
        (res.data.authState == 3 || res.data.authState == 2)
      ) {
        const preCheckRes = await preCheck({});
        this.$store.commit("setPreCheckData", preCheckRes);
        setLocalStorageData("preCheckData", preCheckRes);
        clearInterval(this.timer);
        if (process.env.VUE_APP_ENV === "productionApp") {
           this.$JSBridge.send("serviceType", { type: "12",result:'1' });
        } else {
          this.$router.replace({
            name: "idCardBinding",
          });
        }

        return;
      }
      if (this.time >= 5) {
        clearInterval(this.timer);
        if (process.env.VUE_APP_ENV === "productionApp") {
          this.$JSBridge.send("serviceType", { type: "12",result:'0' });
        } else {
          this.$toast("审核超时，请重新认证");
          this.$router.replace({
            name: "Home",
          });
        }

        return;
      }
    }, 1000);
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped lang="scss">
.idCardLoading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f5f5f5;
}
.content {
  padding: 0px 16px;
}
.progress-block{
  height: 80px;
  width: 100%;
  background: transparent;
}
</style>
